import { useEffect, useState } from 'react';
import {editarUsuarioSistema,crearUsuarioSistema,obtenerUsuarioSistema,reinicioContrasena} from '../data/UsuarioSistema';
import { useContext } from "react";
import { AuthContext } from "auth";

export const useUsuarioSistema = (Usuario={'Genero':'F','CargoId':1}) => {
    var {user}= useContext(AuthContext)
    const [respuestaServicio, setRespuestaServicio] = useState({mensajeTexto:"",estado:false});
    const [usuarioSistema, setUsuarioSistema] = useState(Usuario);
    const getUsuarioSistema = async() => {
       
        if(usuarioSistema.Usuario!=undefined){
            const usuario = await obtenerUsuarioSistema(usuarioSistema.Usuario,user.Token);
            setUsuarioSistema(usuario);
        }
    }
    const updateUsuarioSistema = async() => {
        const respuesta= await editarUsuarioSistema(usuarioSistema,user.Token);
        setRespuestaServicio({estado:respuesta.success,mensajeTexto:respuesta.message})

    }
    const resetPassword=async()=>{
        const respuesta=await reinicioContrasena(usuarioSistema,user.Token);
        setRespuestaServicio({estado:respuesta.success,mensajeTexto:respuesta.message})

    }
    const createUsuarioSistema = async() => {
        const respuesta=await crearUsuarioSistema(usuarioSistema,user.Token);
        setRespuestaServicio({estado:respuesta.success,mensajeTexto:respuesta.message})

    }
    
    useEffect( () => {
        async function setUsuarioSistemaFuncion(){
            getUsuarioSistema();
        }
        setUsuarioSistemaFuncion();
        
    }, []);

    return {
        usuarioSistema,
        setUsuarioSistema,
        updateUsuarioSistema,
        resetPassword,
        createUsuarioSistema,
        respuestaServicio
        

    }
}
